import React, { useState } from "react";
import { useSnackbar } from "notistack";
import { InsertNewEnquiry } from "../../APIs/EnquiryAPI";
import { BaseURL } from "../../APIs/APIUrls";

import avatar from "../../images/avatar/avatar.jpg";

const defaultFormState = {
  name: "",
  phone: "",
  email: "",
  message: "",
};

export default function ContactSeller({ propertyId = 0, VendorProfile = null }) {
  const { enqueueSnackbar } = useSnackbar();
  const [formState, setFormState] = useState(defaultFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateField = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handlePhoneChange = (event) => {
    const onlyDigits = event.target.value.replace(/\D/g, "").slice(0, 10);
    updateField("phone", onlyDigits);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formState.name.trim()) {
      enqueueSnackbar("Please fill in your name.", { variant: "warning" });
      return;
    }

    if (formState.phone.length < 10) {
      enqueueSnackbar("Please enter a valid 10-digit phone number.", { variant: "warning" });
      return;
    }

    if (isSubmitting) {
      enqueueSnackbar("Your enquiry is being submitted. Please wait...", { variant: "info" });
      return;
    }

    const vendorId = JSON.parse(localStorage.getItem("id")) || 0;

    const payload = {
      PropertyId: propertyId || 0,
      VendorId: vendorId,
      Name: formState.name.trim(),
      Mobile: formState.phone,
      Email: formState.email.trim() || null,
      Message: formState.message.trim() || null,
      IsForCall: false,
      IsForWhatsapp: false,
      IsForEnquiry: true,
      IsActive: true,
      CreatedBy: 0,
    };

    setIsSubmitting(true);

    const response = await InsertNewEnquiry(payload);

    setIsSubmitting(false);

    if (response?.success) {
      enqueueSnackbar("Enquiry submitted successfully!", { variant: "success" });
      setFormState(defaultFormState);
      return;
    }

    enqueueSnackbar(response?.message || "Failed to submit enquiry.", { variant: "error" });
  };

  return (
    <>
      <h5 className="title fw-6">Contact Sellers</h5>
      <div className="box-avatar">
        <div className="avatar avt-100 round">
          <img
            alt="avatar"
            src={BaseURL + (VendorProfile?.Photo || avatar)}
            width={100}
            height={100}
          />
        </div>
        <div className="info">
          <h6 className="name">{VendorProfile?.FullName || "Shara Conner"}</h6>
          <ul className="list">
            <li className="d-flex align-items-center gap-4 text-variant-1">
              <i className="icon icon-phone" />
              {VendorProfile?.Phone || "91XXXXXXXX"}
            </li>
            <li className="d-flex align-items-center gap-4 text-variant-1">
              <i className="icon icon-mail" />
              {VendorProfile?.Email || "xxxxxxx@gmail.com"}
            </li>
          </ul>
        </div>
      </div>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="ip-group">
          <input
            type="text"
            placeholder="name..."
            className="form-control"
            value={formState.name}
            onChange={(event) => updateField("name", event.target.value)}
            required
          />
        </div>
        <div className="ip-group">
          <input
            type="tel"
            placeholder="phone..."
            className="form-control"
            inputMode="numeric"
            value={formState.phone}
            onChange={handlePhoneChange}
            required
          />
        </div>
        <div className="ip-group">
          <input
            type="email"
            placeholder="email..."
            className="form-control"
            value={formState.email}
            onChange={(event) => updateField("email", event.target.value)}
          />
        </div>
        <div className="ip-group">
          <textarea
            id="comment-message"
            name="message"
            rows={4}
            tabIndex={4}
            placeholder="message..."
            aria-required="true"
            className="form-control"
            value={formState.message}
            onChange={(event) => updateField("message", event.target.value)}
          />
        </div>
        <button
          type="submit"
          className="tf-btn btn-view primary hover-btn-view w-100"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Enquire"}
          <span className="icon icon-arrow-right2" />
        </button>
      </form>
    </>
  );
}
